(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[809],{

/***/ 9443:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/member",
      function () {
        return __webpack_require__(5604);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 1796:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ CommonMeta; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9008);


function CommonMeta(param) {
    var _title = param.title, title = _title === void 0 ? "TV\u30A2\u30CB\u30E1\u300E\u60D1\u661F\u306E\u3055\u307F\u3060\u308C\u300F\u516C\u5F0F\u30B5\u30A4\u30C8" : _title, _description = param.description, description = _description === void 0 ? "\u300C\u60D1\u661F\uFF08\u307B\u3057\uFF09\u306E\u3055\u307F\u3060\u308C\u300D2022\u5E74\u590FTV\u30A2\u30CB\u30E1\u653E\u9001\u958B\u59CB\uFF01" : _description;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(next_head__WEBPACK_IMPORTED_MODULE_1__["default"], {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                children: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "description",
                content: description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:title",
                content: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:description",
                content: description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image",
                content: "".concat("https://hoshinosamidare.jp", "/images/ogp.png")
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:card",
                content: "summary_large_image"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "viewport",
                content: "width=device-width,initial-scale=1.0,viewport-fit=cover"
            })
        ]
    });
};


/***/ }),

/***/ 6127:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": function() { return /* binding */ LightSkyLayout; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(8527);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5934);
/* harmony import */ var framer_motion__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2748);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _head_commonMeta__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1796);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n    background: linear-gradient(180deg, #0c062d 0%, #4264e0 7.63%, #6ac3ff 60.06%),\n        linear-gradient(180deg, #0c062d 0%, #6ac3ff 100%);\n    width: 100vw;\n    min-height: 100vh;\n    background-attachment: local;\n    @media (max-width: ",
        "px) {\n        background: linear-gradient(180deg, #0c062d 0%, #4264e0 4.23%, #6ac3ff 60.06%),\n            linear-gradient(180deg, #0c062d 0%, #6ac3ff 100%);\n        background-size: 600px;\n    }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n    position: absolute;\n    top: 0;\n    left: 0;\n    height: 100%;\n    background: url(/images/bg-top-side.png) no-repeat center top;\n    width: 26%;\n    @media (max-width: ",
        "px) {\n        display: none;\n    }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n    display: none;\n    @media (max-width: ",
        "px) {\n        position: relative;\n        display: block;\n        height: 140px;\n        width: 100%;\n        background: url(/images/bg-top-sp.png) no-repeat;\n        background-position: center top;\n        background-size: cover;\n    }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n    flex: 1;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n    display: flex;\n    text-shadow: 0px 0px 30px #004a7c;\n    position: absolute;\n    top: 40px;\n    left: 132px;\n    font-size: 96px;\n    transform: translateX(calc(-50% + 32px)) rotate(90deg);\n    @media (max-width: 1155px) {\n        font-size: 50px;\n        top: 26px;\n        left: 56px;\n        transform: translateX(calc(-50% + 32px)) rotate(90deg);\n    }\n    @media (max-width: ",
        "px) {\n        display: none;\n    }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n    display: none;\n    @media (max-width: ",
        "px) {\n        display: inline-block;\n        position: absolute;\n        text-shadow: 0px 0px 30px #004a7c;\n        top: 50%;\n        left: 50%;\n        transform: translateY(-50%) translateX(-50%);\n        font-weight: 400;\n        font-size: 36px;\n    }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n    position: absolute;\n    top: -36%;\n    left: 15%;\n    height: 250vh;\n    margin: auto;\n    transform: rotate(45deg);\n    width: 100vw;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n    position: absolute;\n    width: 1px;\n    height: 80%;\n    top: 0;\n    left: 50%;\n\n    &::after {\n        content: '';\n        display: block;\n        position: absolute;\n        height: 100vh;\n        width: 100%;\n        top: -60%;\n        left: 0;\n        background-color: #ffffff;\n        animation: drop 6s 0s infinite;\n        animation-fill-mode: forwards;\n    }\n\n    :first-of-type {\n        margin-left: -45%;\n        &::after {\n            animation-delay: 1.2s;\n        }\n    }\n    :nth-of-type(2) {\n        margin-left: 12px;\n        &::after {\n            zoom: 0.5;\n            animation-delay: -0.2s;\n        }\n    }\n    :nth-of-type(3) {\n        margin-left: -28%;\n        &::after {\n            animation-delay: 4.5s;\n        }\n    }\n    :nth-of-type(4) {\n        margin-left: 18%;\n        &::after {\n            animation-delay: 3.3s;\n        }\n    }\n    :last-of-type {\n        margin-left: 35%;\n        &::after {\n            animation-delay: 2.5s;\n        }\n    }\n\n    @keyframes drop {\n        0% {\n            top: -45%;\n            height: 100vw;\n        }\n        80% {\n            height: 0;\n        }\n        100% {\n            height: 0;\n            top: 100%;\n        }\n    }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "\n    background: url(/images/bg-bottom-half.png) no-repeat bottom;\n    bottom: 0;\n    text-align: center;\n    font-size: 0.92rem;\n    font-weight: bold;\n    color: #ffffff;\n    letter-spacing: 0.1em;\n    width: 100vw;\n    padding-bottom: 88px;\n    display: flex;\n    align-items: end;\n    justify-content: center;\n    background-size: cover;\n    background-repeat: no-repeat;\n    @media (max-width: ",
        "px) {\n        padding-bottom: 48px;\n        font-size: 0.62rem;\n    }\n    @media (max-width: ",
        "px) {\n        background: url(/images/bg-bottom-sp.png) no-repeat bottom;\n        padding-bottom: 16px;\n        font-size: 0.62rem;\n    }\n    @media (orientation: landscape) and (max-width: ",
        "px) {\n        font-size: 0.62rem;\n    }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}






var spWidth = 599;
var pcWidth = 1024;
var tabletWidth = 912;
var Bg = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div */ .Z.div(_templateObject(), spWidth);
var Sky = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"].header */ .Z.header(_templateObject1(), spWidth);
var SkySp = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"].header */ .Z.header(_templateObject2(), spWidth);
var Main = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"].main */ .Z.main(_templateObject3());
var PageTitle = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div */ .Z.div(_templateObject4(), spWidth);
var PageTitleSp = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div */ .Z.div(_templateObject5(), spWidth);
var Stars = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div */ .Z.div(_templateObject6());
var Star = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div */ .Z.div(_templateObject7());
var Footer = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"].footer */ .Z.footer(_templateObject8(), tabletWidth, spWidth, pcWidth);
var LightSkyLayout = function(param) {
    var children = param.children, pageTitle = param.pageTitle;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(framer_motion__WEBPACK_IMPORTED_MODULE_4__/* .motion.div */ .E.div, {
        animate: {
            opacity: 1
        },
        initial: {
            opacity: 0
        },
        exit: {
            opacity: 0
        },
        transition: {
            duration: 0.5
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Bg, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Sky, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(PageTitle, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: "absolute text-c-secondary w-max h-20 font-RocknRoll tracking-widest",
                            children: pageTitle
                        })
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Main, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_head_commonMeta__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {}),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "relative w-screen h-[140vh] overflow-hidden pointer-events-none",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Stars, {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Star, {}),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Star, {}),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Star, {}),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Star, {}),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Star, {}),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Star, {})
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(framer_motion__WEBPACK_IMPORTED_MODULE_4__/* .motion.h1 */ .E.h1, {
                            animate: {
                                opacity: 1,
                                y: 0
                            },
                            initial: {
                                opacity: 0,
                                y: -100
                            },
                            exit: {
                                opacity: 0
                            },
                            transition: {
                                duration: 1
                            },
                            className: "-mt-[140vh] relative md:w-5/6 w-3/6 max-w-sm lg:h-[24vw] h-[34vw] mx-auto",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_5__/* .Link */ .rU, {
                                href: "/",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                                    src: "/images/logo.svg",
                                    alt: "\u60D1\u661F\uFF08\u307B\u3057\uFF09\u306E\u3055\u307F\u3060\u308C",
                                    layout: "fill",
                                    objectFit: "contain"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SkySp, {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(PageTitleSp, {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    className: "text-c-secondary font-bold w-max font-RocknRoll tracking-widest",
                                    children: pageTitle
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "w-full relative z-[1] mt-8",
                            children: children
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Footer, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("small", {
                        className: "md:pt-[25%] pt-[155%]",
                        children: "\xa9\u6C34\u4E0A\u609F\u5FD7\u30FB\u5C11\u5E74\u753B\u5831\u793E\uFF0F\u3042\u308B\u6642\u4EE3\u306E\u6307\u8F2A\u306E\u9A0E\u58EB\u56E3"
                    })
                })
            ]
        })
    });
};


/***/ }),

/***/ 5604:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ member; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 2 modules
var emotion_styled_browser_esm = __webpack_require__(5934);
;// CONCATENATED MODULE: ./src/components/global/CCaptionCard.tsx
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n    background: rgba(255, 255, 0, 0.75);\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var CaptionCardInner = emotion_styled_browser_esm/* default.div */.Z.div(_templateObject());
var CaptionCard = function(param) {
    var src = param.src, furigana = param.furigana, character = param.character, talent = param.talent, caption = param.caption, valet = param.valet;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(CaptionCardInner, {
        className: "flex flex-col text-center max-w-sm mx-auto",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                src: src,
                alt: character,
                className: "object-cover w-full relative aspect-video"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "p-4 flex flex-col h-auto w-full",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-col mt-2 w-full font-semibold text-2xl",
                        children: [
                            furigana && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "text-sm",
                                children: furigana
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "flex m-auto text-2xl border-b-4 mt-0 border-c-secondary",
                                children: character
                            })
                        ]
                    }),
                    talent && /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        className: "text-xl w-full mt-2 leading-none font-semibold",
                        children: [
                            "CV : ",
                            talent
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "mt-4 text-base font-normal text-left",
                        children: caption
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "mt-4 text-base font-normal text-left",
                        children: valet
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var CCaptionCard = (CaptionCard);

// EXTERNAL MODULE: ./src/components/layout/LightSky.tsx
var LightSky = __webpack_require__(6127);
;// CONCATENATED MODULE: ./src/pages/member/index.tsx



var Member = function() {
    var memberItems = [
        {
            src: "/images/member/yuuhi.jpeg",
            character: "\u96E8\u5BAE \u5915\u65E5",
            furigana: "\u3042\u307E\u307F\u3084\u3000\u3086\u3046\u3072",
            caption: "\u30C8\u30AB\u30B2\u306E\u9A0E\u58EB\u3002\u3042\u308B\u671D\u3001\u7A81\u7136\u73FE\u308C\u305F\u30C8\u30AB\u30B2\u306E\u5F93\u8005\u30CE\u30A4\u306B\u3088\u3063\u3066\u9A0E\u58EB\u306B\u9078\u3070\u308C\u308B\u3002\u3055\u307F\u3060\u308C\u306E\u7834\u5929\u8352\u306A\u91CE\u671B\u306E\u524D\u306B\u5FE0\u8AA0\u3092\u8A93\u3044\u3001\u5171\u306B\u5730\u7403\u306E\u7834\u58CA\u3092\u4F01\u3080\u3002\u638C\u63E1\u9818\u57DF\u306F\u300C\u638C\u63E1\u7A7A\u57DF \u5929\u306E\u5EAD\uFF08\u30D0\u30D3\u30ED\u30F3\uFF09\u300D\u3002",
            valet: "\u5F93\u8005: \u30CE\u30A4\uFF1D\u30AF\u30EC\u30B6\u30F3\u30C8",
            talent: "\u698E\u6728 \u6DF3\u5F25"
        },
        {
            src: "/images/member/samidare.jpeg",
            character: "\u671D\u65E5\u5948 \u3055\u307F\u3060\u308C",
            furigana: "\u3042\u3055\u3072\u306A \u3055\u307F\u3060\u308C",
            caption: "\u6307\u8F2A\u306E\u5F93\u8005\u304C\u5B88\u308B\u3079\u304D\u59EB\u3002\u95A2\u897F\u5F01\u306E\u5143\u6C17\u3044\u3063\u3071\u3044\u5C11\u5973\u3002\u7CBE\u970A\u30A2\u30CB\u30DE\u306E\u529B\u3067\u7206\u767A\u7684\u306A\u653B\u6483\u529B\u3092\u6301\u3064\u3002\u30A2\u30CB\u30E0\u30B9\u3092\u5012\u3057\u305F\u3042\u304B\u3064\u304D\u306B\u306F\u3001\u4E16\u754C\u3092\u6C38\u9060\u306B\u81EA\u5206\u306E\u7269\u306B\u3059\u308B\u305F\u3081\u306B\u5730\u7403\u306E\u7834\u58CA\u3092\u4F01\u3093\u3067\u3044\u308B\u3002",
            valet: "\u7CBE\u970A: \u30A2\u30CB\u30DE",
            talent: "\u5927\u7A7A \u76F4\u7F8E"
        },
        {
            src: "/images/member/noi.jpg",
            character: "\u30CE\u30A4\uFF1D\u30AF\u30EC\u30B6\u30F3\u30C8",
            caption: "\u30C8\u30AB\u30B2\u306E\u5F93\u8005\u3002\u9A0E\u58EB\u9053\u7CBE\u795E\u3092\u91CD\u3093\u3058\u3001\u6B63\u7FA9\u611F\u304C\u5F37\u304F\u751F\u771F\u9762\u76EE\u3002\u5915\u65E5\u304C\u3055\u307F\u3060\u308C\u3068\u5171\u306B\u5730\u7403\u3092\u58CA\u3059\u8A08\u753B\u3092\u963B\u6B62\u3057\u305F\u3044\u3068\u601D\u3044\u3064\u3064\u3082\u3001\u5915\u65E5\u306E\u6210\u9577\u3092\u9593\u8FD1\u3067\u898B\u5B88\u308B\u3002",
            talent: "\u6D25\u7530 \u5065\u6B21\u90CE"
        },
        {
            src: "/images/member/anima.jpg",
            character: "\u30A2\u30CB\u30DE",
            caption: "\u3055\u307F\u3060\u308C\u3068\u5951\u7D04\u3092\u4EA4\u308F\u3057\u305F\u7CBE\u970A\uFF08\u30D7\u30EA\u30F3\u30BB\u30B9\uFF09\u3002\u30A2\u30CB\u30E0\u30B9\u306E\u53CC\u5B50\u306E\u59B9\u3002\u3042\u307E\u308A\u306E\u30DE\u30A4\u30DA\u30FC\u30B9\u3055\u306B\u3001\u7363\u306E\u5F93\u8005\u9054\u306F\u3044\u3064\u3082\u632F\u308A\u56DE\u3055\u308C\u3066\u3044\u308B\u3002",
            talent: "M\u30FBA\u30FBO"
        },
        {
            src: "/images/member/anims.jpg",
            character: "\u30A2\u30CB\u30E0\u30B9",
            caption: "\u5F37\u5927\u306A\u529B\u3092\u6301\u3063\u305F\u9B54\u6CD5\u4F7F\u3044\u3002\u30A2\u30CB\u30DE\u306E\u53CC\u5B50\u306E\u5144\u3002\u5E38\u306B\u8131\u529B\u3057\u305F\u30B9\u30BF\u30A4\u30EB\u3067\u98C4\u3005\u3068\u73FE\u308F\u308C\u308B\u304C\u3001\u5168\u3066\u306E\u59CB\u307E\u308A\u3092\u77E5\u308B\u305F\u3081\u306B\u5730\u7403\u306E\u7834\u58CA\u3092\u7E70\u308A\u8FD4\u3057\u3066\u3044\u308B\u3002",
            talent: "\u6A58 \u9F8D\u4E38"
        },
        {
            src: "/images/member/hangetsu.jpg",
            character: "\u6771\u96F2 \u534A\u6708",
            furigana: "\u3057\u306E\u306E\u3081 \u306F\u3093\u3052\u3064",
            caption: "\u72AC\u306E\u9A0E\u58EB\u3002\u53E4\u6B66\u8853\u306E\u9054\u4EBA\u3067\u3001\u88CF\u793E\u4F1A\u3067\u306F\u300C\u98A8\u795E\u300D\u306E\u7570\u540D\u3092\u6301\u3064\u3002\u7363\u306E\u9A0E\u58EB\u306E\u4E2D\u3067\u3082\u98DB\u3073\u629C\u3051\u3066\u6226\u95D8\u529B\u304C\u9AD8\u304F\u3001\u3055\u307F\u3060\u308C\u3068\u5915\u65E5\u306B\u6226\u3044\u65B9\u3092\u6559\u3048\u308B\u3002\u638C\u63E1\u9818\u57DF\u306F\u69CD\u306E\u3088\u3046\u306A\u529B\u5834\u3092\u6575\u306B\u6253\u3061\u8FBC\u3080\u300C\u65B9\u5929\u621F\uFF08\u307B\u3046\u3066\u3093\u3052\u304D\uFF09\u300D\u3002",
            valet: "\u5F93\u8005: \u30EB\u30C9\uFF1D\u30B7\u30E5\u30D0\u30EA\u30A8",
            talent: "\u5CA9\u702C \u5468\u5E73"
        },
        {
            src: "/images/member/mikazuki.jpeg",
            character: "\u6771\u96F2 \u4E09\u65E5\u6708",
            furigana: "\u3057\u306E\u306E\u3081 \u307F\u304B\u3065\u304D",
            caption: "\u30AB\u30E9\u30B9\u306E\u9A0E\u58EB\u3002\u534A\u6708\u306E\u5F1F\u3067\u3001\u5F37\u5927\u306A\u5144\u306E\u80CC\u3092\u8FFD\u3044\u7D9A\u3051\u3066\u3044\u308B\u3002\u666E\u6BB5\u306F\u793E\u4EA4\u7684\u306A\u6027\u683C\u3060\u304C\u6226\u95D8\u72C2\u3067\u3001\u5F37\u8005\u3067\u3042\u308C\u3070\u6575\u5473\u65B9\u3092\u554F\u308F\u305A\u95D8\u3044\u3092\u671B\u3080\u3002\u638C\u63E1\u9818\u57DF\u306F\u3001\u69CD\u72B6\u306E\u65B9\u5929\u621F\u3092\u5927\u91CF\u306B\u964D\u3089\u305B\u3066\u653B\u6483\u3092\u304A\u3053\u306A\u3046\u300C\u5C01\u5929\u9663\uFF08\u307B\u3046\u3066\u3093\u3058\u3093\uFF09\u300D\u3002",
            valet: "\u5F93\u8005: \u30E0\u30FC",
            talent: "\u4F50\u85E4 \u5143"
        },
        {
            src: "/images/member/soichiro.jpeg",
            character: "\u5357\u96F2 \u5B97\u4E00\u6717",
            furigana: "\u306A\u3050\u3082 \u305D\u3046\u3044\u3061\u308D\u3046",
            caption: "\u99AC\u306E\u9A0E\u58EB\u3002\u5143\u5211\u4E8B\u3002\u9A0E\u58EB\u305F\u3061\u306E\u30EA\u30FC\u30C0\u30FC\u7684\u5B58\u5728\u3067\u3001\u8CAC\u4EFB\u611F\u304C\u5F37\u304F\u751F\u771F\u9762\u76EE\u306A\u6027\u683C\u3002\u638C\u63E1\u9818\u57DF\u306F\u5E73\u9762\u72B6\u306E\u529B\u5834\u3067\u76F8\u624B\u3092\u62D8\u675F\u3059\u308B\u300C\u50BE\u5929\u5E73\u9762\uFF08\u305F\u304B\u307E\u304C\u306F\u3089\uFF09\u300D\u3002",
            valet: "\u5F93\u8005: \u30C0\u30F3\u30B9\uFF1D\u30C0\u30FC\u30AF",
            talent: "\u7A32\u7530 \u5FB9"
        },
        {
            src: "/images/member/yayoi.jpeg",
            character: "\u767D\u9053 \u516B\u5BB5",
            furigana: "\u306F\u304F\u3069\u3046 \u3084\u3088\u3044",
            caption: "\u86C7\u306E\u9A0E\u58EB\u3002\u30B9\u30BF\u30A4\u30EB\u306E\u826F\u3044\u304A\u3063\u3068\u308A\u7F8E\u4EBA\u3060\u304C\u3001\u6728\u5200\u3092\u6301\u3064\u3068\u679C\u65AD\u306A\u5224\u65AD\u529B\u3092\u6301\u3064\u5263\u58EB\u306B\u3002\u8DA3\u5473\u306F\u30B3\u30B9\u30D7\u30EC\u3060\u304C\u3001\u4ED6\u4EBA\u306B\u306F\u79D8\u5BC6\u306B\u3057\u3066\u3044\u308B\u3002\u638C\u63E1\u9818\u57DF\u306F\u6B66\u5668\u306B\u7E8F\u308F\u305B\u308B\u7D10\u72B6\u306E\u300C\u708E\u72B6\u5203\uFF08\u30D5\u30E9\u30F3\u30D9\u30EB\u30B8\u30E5\uFF09\u300D\u3002",
            valet: "\u5F93\u8005: \u30B7\u30A2\uFF1D\u30E0\u30FC\u30F3",
            talent: "\u6D32\u5D0E \u7DBE"
        },
        {
            src: "/images/member/shimaki.jpg",
            character: "\u98A8\u5DFB \u8C79",
            furigana: "\u3057\u307E\u304D \u3072\u3087\u3046",
            caption: "\u9ED2\u732B\u306E\u9A0E\u58EB\u3002\u5927\u5B66\u306B\u52E4\u3081\u3066\u5FC3\u7406\u5B66\u306E\u7814\u7A76\u3092\u3057\u3066\u3044\u308B\u6E29\u548C\u306A\u6027\u683C\u306E\u7537\u6027\u3002\u638C\u63E1\u9818\u57DF\u306F\u6CE5\u4EBA\u5F62\u3092\u5275\u308B\u300C\u5275\u9020\u9818\u57DF \u5730\u6BCD\u795E\uFF08\u30AD\u30E5\u30D9\u30EC\u30A4\uFF09\u300D\u3002",
            valet: "\u5F93\u8005: \u30AF\u30FC\uFF1D\u30EA\u30C3\u30BF\u30FC",
            talent: "\u677E\u5CA1 \u798E\u4E1E"
        },
        {
            src: "/images/member/taro.jpg",
            character: "\u65E5\u4E0B\u90E8 \u592A\u6717",
            furigana: "\u304F\u3055\u304B\u3079 \u305F\u308D\u3046",
            caption: "\u30CD\u30BA\u30DF\u306E\u9A0E\u58EB\u3002\u9AD8\u6821\u751F\u3002\u82B1\u5B50\u3068\u306F\u5E7C\u99B4\u67D3\u3002\u6599\u7406\u4EBA\u3092\u76EE\u6307\u3057\u3066\u304A\u308A\u3001\u5915\u65E5\u3068\u4E09\u65E5\u6708\u304C\u98F2\u3080\u969B\u306F\u304A\u3064\u307E\u307F\u4F5C\u308A\u3092\u62C5\u5F53\u3057\u3066\u3044\u308B\u3002\u638C\u63E1\u9818\u57DF\u306F\u7269\u4F53\u3092\u7D30\u304B\u304F\u5207\u308A\u523B\u307F\u3001\u9AD8\u6E29\u3092\u767A\u751F\u3055\u305B\u7740\u706B\u3059\u308B\u300C\u8352\u795E\uFF08\u3042\u3089\u304C\u307F\uFF09\u300D\u3002",
            valet: "\u5F93\u8005: \u30E9\u30F3\u30B9\uFF1D\u30EA\u30E5\u30DF\u30A8\u30FC\u30EB",
            talent: "\u571F\u5C90 \u96BC\u4E00"
        },
        {
            src: "/images/member/hanako.jpg",
            character: "\u5B99\u91CE \u82B1\u5B50",
            furigana: "\u305D\u3089\u306E \u306F\u306A\u3053",
            caption: "\u30AB\u30DE\u30AD\u30EA\u306E\u9A0E\u58EB\u3002\u9AD8\u6821\u751F\u3002\u6210\u7E3E\u512A\u79C0\u306A\u9AD8\u6821\u751F\u3067\u592A\u6717\u3068\u306F\u5E7C\u99B4\u67D3\u3002\u559C\u6012\u54C0\u697D\u306E\u611F\u60C5\u304C\u5E0C\u8584\u3002\u638C\u63E1\u9818\u57DF\u306F\u5206\u5B50\u3092\u3064\u307E\u3093\u3067\u77AC\u6642\u306B\u51CD\u3089\u305B\u308B\u300C\u3088\u304F\u51B7\u3048\uFF5E\u308B\uFF01\uFF1F\u300D\u3002",
            valet: "\u5F93\u8005: \u30AD\u30EB\uFF1D\u30BE\u30F3\u30CD",
            talent: "\u5EE3\u702C \u5343\u590F"
        },
        {
            src: "/images/member/subaru.jpg",
            character: "\u661F\u5DDD \u6634",
            furigana: "\u307B\u3057\u304B\u308F \u3059\u3070\u308B",
            caption: "\u9D8F\u306E\u9A0E\u58EB\u3002\u4E2D\u5B661\u5E74\u751F\u3067\u96EA\u5F85\u3068\u306F\u5E7C\u99B4\u67D3\u3002\u898B\u305F\u76EE\u3084\u666E\u6BB5\u306E\u614B\u5EA6\u3068\u53CD\u3057\u3066\u3001\u6C17\u5F31\u306A\u4E00\u9762\u3082\u3042\u308B\u3002\u638C\u63E1\u9818\u57DF\u306F\u96EA\u5F85\u30682\u4EBA\u3067\u5F62\u6210\u3059\u308B\u300C\u7121\u6575\u306E\u76FE\u300D\u3068\u300C\u6700\u5F37\u306E\u77DB\u300D\u3002",
            valet: "\u5F93\u8005: \u30EA\u30FC\uFF1D\u30BD\u30EC\u30A4\u30E6",
            talent: "\u5409\u6B66 \u5343\u98AF"
        },
        {
            src: "/images/member/yukimachi.jpg",
            character: "\u6708\u4EE3 \u96EA\u5F85",
            furigana: "\u3064\u304D\u3057\u308D \u3086\u304D\u307E\u3061",
            caption: "\u4E80\u306E\u9A0E\u58EB\u3002\u4E2D\u5B661\u5E74\u751F\u3067\u6634\u3068\u306F\u5E7C\u99B4\u67D3\u3002\u3086\u3063\u305F\u308A\u3068\u3057\u305F\u7269\u8170\u3060\u304C\u3001\u3044\u3056\u3068\u3044\u3046\u6642\u306B\u6C7A\u65AD\u3067\u304D\u308B\u6C17\u6301\u3061\u306E\u5F37\u3055\u3092\u6301\u3063\u3066\u3044\u308B\u3002\u638C\u63E1\u9818\u57DF\u306F\u6634\u30682\u4EBA\u3067\u5F62\u6210\u3059\u308B\u300C\u7121\u6575\u306E\u76FE\u300D\u3068\u300C\u6700\u5F37\u306E\u77DB\u300D\u3002",
            valet: "\u5F93\u8005: \u30ED\u30F3\uFF1D\u30E6\u30A8",
            talent: "\u5F8C\u672C \u840C\u8449"
        },
        {
            src: "/images/member/taiyo.jpg",
            character: "\u831C \u592A\u967D",
            furigana: "\u3042\u304B\u306D \u305F\u3044\u3088\u3046",
            caption: "\u30D5\u30AF\u30ED\u30A6\u306E\u9A0E\u58EB\u300212\u6B73\u3002\u5BB6\u5EAD\u74B0\u5883\u306E\u305B\u3044\u304B\u508D\u89B3\u8005\u7684\u306A\u614B\u5EA6\u3092\u53D6\u308B\u3053\u3068\u304C\u591A\u3044\u3002\u30A2\u30CB\u30E0\u30B9\u3068\u306E\u6226\u3044\u306B\u98FD\u3044\u305F\u5F93\u8005\u30ED\u30AD\u306E\u5FE0\u544A\u3092\u805E\u304D\u3001\u30A2\u30CB\u30E0\u30B9\u3068\u63A5\u89E6\u3057\u3066\u3044\u308B\u3002\u638C\u63E1\u9818\u57DF\u306F\u6642\u9593\u3092\u304B\u304D\u4E71\u3059\u80FD\u529B\u3001\u6DF7\u6C8C\u9818\u57DF\u300C\u56E0\u679C\u4E71\u6D41\uFF08\u30D1\u30F3\u30C9\u30E9\uFF09\u300D\u3002",
            valet: "\u5F93\u8005: \u30ED\u30AD\uFF1D\u30D8\u30EA\u30AA\u30B9",
            talent: "\u7530\u6751 \u7766\u5FC3"
        },
        {
            src: "/images/member/inachika.jpg",
            character: "\u79CB\u8C37 \u7A32\u8FD1",
            furigana: "\u3042\u304D\u305F\u306B \u3044\u306A\u3061\u304B",
            caption: "\u30AB\u30B8\u30AD\u30DE\u30B0\u30ED\u306E\u9A0E\u58EB\u3002500\u5E74\u9593\u3092\u751F\u304D\u7D9A\u3051\u305F\u8D85\u80FD\u529B\u8005\u3067\u3001\u96EA\u5F85\u3001\u6634\u306E\u300C\u5E2B\u5320\u300D\u3068\u3057\u3066\u3001\u4E8C\u4EBA\u3092\u935B\u3048\u305F\u3002\u638C\u63E1\u9818\u57DF\u306F\u96F7\u6483\u3092\u843D\u3068\u3059\u300C\u5929\u6CBC\u77DB\uFF08\u30A2\u30DE\u30CE\u30CC\u30DC\u30B3\uFF09\u300D\u3002",
            valet: "\u5F93\u8005: \u30B6\u30F3\uFF1D\u30A2\u30DE\u30EB",
            talent: "\u5C71\u8DEF \u548C\u5F18"
        },
        {
            src: "/images/member/ludo.jpg",
            character: "\u30EB\u30C9\uFF1D\u30B7\u30E5\u30D0\u30EA\u30A8",
            caption: "\u72AC\u306E\u5F93\u8005\u3002\u534A\u6708\u306F\u5E7C\u3044\u9803\u306B\u98FC\u3063\u3066\u3044\u305F\u72AC\u306E\u540D\u3067\u3042\u308B\u300C\u30CE\u30B3\u300D\u3068\u547C\u3093\u3067\u3044\u308B\u304C\u30EB\u30C9\u672C\u4EBA\u306F\u6C17\u306B\u5165\u3063\u3066\u3044\u306A\u3044\u3002\u524D\u56DE\u306E\u6226\u3044\u3067\u306F\u6700\u5F8C\u307E\u3067\u751F\u304D\u6B8B\u3063\u305F\u3002",
            talent: "\u77F3\u6BDB \u7FD4\u5F25"
        },
        {
            src: "/images/member/moo.jpeg",
            character: "\u30E0\u30FC",
            caption: "\u30AB\u30E9\u30B9\u306E\u5F93\u8005\u3002\u7121\u53E3\u3067\u307B\u3068\u3093\u3069\u8A00\u8449\u3092\u767A\u3057\u306A\u3044\u3002",
            talent: "\u7530\u4E2D \u6566\u5B50"
        },
        {
            src: "/images/member/dark.jpg",
            character: "\u30C0\u30F3\u30B9\uFF1D\u30C0\u30FC\u30AF",
            caption: "\u99AC\u306E\u5F93\u8005\u3002\u7537\u306F\u4E57\u305B\u306A\u3044\u4E3B\u7FA9\u3067\u3001\u5357\u96F2\u3092\u632F\u308A\u843D\u3068\u3057\u3066\u8170\u3092\u8CA0\u50B7\u3055\u305B\u305F\u4E8B\u304C\u3042\u308B\u3002",
            talent: "\u718A\u8C37 \u5065\u592A\u90CE"
        },
        {
            src: "/images/member/sia.jpeg",
            character: "\u30B7\u30A2\uFF1D\u30E0\u30FC\u30F3",
            caption: "\u86C7\u306E\u5F93\u8005\u3002\u6027\u683C\u306F\u304A\u8ABF\u5B50\u8005\u3067\u3001\u516B\u5BB5\u306E\u3053\u3068\u3092\u300C\u3084\u30FC\u3053\u300D\u3068\u547C\u3076\u3002",
            talent: "\u6C37\u9752"
        },
        {
            src: "/images/member/qoo.jpg",
            character: "\u30AF\u30FC\uFF1D\u30EA\u30C3\u30BF\u30FC",
            caption: "\u9ED2\u732B\u306E\u5F93\u8005\u3002\u3057\u3063\u3068\u308A\u3057\u305F\u53E3\u8ABF\u3067\u8A9E\u5C3E\u306F\u300C\uFF5E\u306A\u306E\u300D\u3002",
            talent: "\u639B\u5DDD \u6E1A"
        },
        {
            src: "/images/member/lance.jpg",
            character: "\u30E9\u30F3\u30B9\uFF1D\u30EA\u30E5\u30DF\u30A8\u30FC\u30EB",
            caption: "\u30CD\u30BA\u30DF\u306E\u5F93\u8005\u3002\u30AD\u30EB\u3068\u306F\u30B1\u30F3\u30AB\u3092\u3057\u3064\u3064\u3082\u304A\u4E92\u3044\u3092\u6C17\u306B\u304B\u3051\u3066\u3044\u308B\u3002",
            talent: "\u5C71\u672C \u548C\u81E3"
        },
        {
            src: "/images/member/kile.jpg",
            character: "\u30AD\u30EB\uFF1D\u30BE\u30F3\u30CD",
            caption: "\u30AB\u30DE\u30AD\u30EA\u306E\u5F93\u8005\u3002\u4E00\u898B\u51B7\u9177\u3067\u8584\u60C5\u306A\u6027\u683C\u3060\u304C\u3001\u60C5\u306B\u71B1\u3044\u4E00\u9762\u3082\u6301\u3063\u3066\u3044\u308B\u3002",
            talent: "\u9752\u6728 \u7460\u7483\u5B50"
        },
        {
            src: "/images/member/lee.jpg",
            character: "\u30EA\u30FC\uFF1D\u30BD\u30EC\u30A4\u30E6",
            caption: "\u9D8F\u306E\u5F93\u8005\u3002\u77ED\u6C17\u3067\u597D\u6226\u7684\u306A\u6027\u683C\u3002\u6634\u3092\u5A18\u306E\u3088\u3046\u306B\u601D\u3063\u3066\u3044\u308B\u3002",
            talent: "\u5CA9\u7530 \u5149\u592E"
        },
        {
            src: "/images/member/ron.jpg",
            character: "\u30ED\u30F3\uFF1D\u30E6\u30A8",
            caption: "\u4E80\u306E\u5F93\u8005\u3002\u8001\u4EBA\u3089\u3057\u304F\u306E\u3093\u3073\u308A\u3057\u305F\u6027\u683C\u3002",
            talent: "\u68EE \u529F\u81F3"
        },
        {
            src: "/images/member/loki.jpg",
            character: "\u30ED\u30AD\uFF1D\u30D8\u30EA\u30AA\u30B9",
            caption: "\u30D5\u30AF\u30ED\u30A6\u306E\u5F93\u8005\u3002\u54F2\u5B66\u8005\u306E\u3088\u3046\u306A\u53E3\u8ABF\u3067\u8A71\u3059\u3002\u30A2\u30CB\u30E0\u30B9\u306B\u52DD\u3066\u306A\u3044\u6226\u3044\u3092\u7D9A\u3051\u308B\u4E8B\u306B\u7591\u554F\u3092\u6301\u3063\u3066\u3044\u308B\u3002",
            talent: "\u6751\u6CBB \u5B66"
        },
        {
            src: "/images/member/zan.jpg",
            character: "\u30B6\u30F3\uFF1D\u30A2\u30DE\u30EB",
            caption: "\u30AB\u30B8\u30AD\u30DE\u30B0\u30ED\u306E\u5F93\u8005\u3002\u898B\u305F\u76EE\u901A\u308A\u306E\u30A4\u30F3\u30D1\u30AF\u30C8\u3067\u3001\u7A32\u8FD1\u3092\u9A5A\u6115\u3055\u305B\u305F\u3002",
            talent: "\u4F4F\u8C37 \u54F2\u6804"
        },
        {
            src: "/images/member/hisame.jpeg",
            character: "\u671D\u65E5\u5948 \u6C37\u96E8",
            furigana: "\u3042\u3055\u3072\u306A \u3072\u3055\u3081",
            caption: "\u5915\u65E5\u306E\u901A\u3046\u5927\u5B66\u306E\u52A9\u6559\u6388\u3067\u3001\u3055\u307F\u3060\u308C\u306E\u59C9\u3002\u59B9\u3092\u6EBA\u611B\u3057\u3066\u3044\u308B\u300227\u6B73\u3067\u535A\u58EB\u53F7\u3092\u53D6\u5F97\u3002\u534A\u6708\u306B\u597D\u610F\u3092\u6301\u305F\u308C\u308B\u3002",
            talent: "\u7530\u6240 \u3042\u305A\u3055"
        }, 
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(LightSky/* LightSkyLayout */.N, {
        pageTitle: "\u30AD\u30E3\u30E9\u30AF\u30BF\u30FC",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "grid gap-x-10 gap-y-14 grid-cols-1 md:grid-cols-2 lg:grid-cols-3 mt-16 md:mt-10 mx-auto px-4 max-w-6xl",
            children: memberItems.map(function(member, i) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(CCaptionCard, {
                    src: member.src,
                    furigana: member.furigana,
                    character: member.character,
                    talent: member.talent,
                    caption: member.caption,
                    valet: member.valet
                }, i);
            })
        })
    });
};
/* harmony default export */ var member = (Member);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [774,888,179], function() { return __webpack_exec__(9443); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);